import { useState } from 'react';
import { LayoutDashboard, Users, Settings, History, BookOpen } from 'lucide-react';
import MetaAdsDashboard from './MetaAdsDashboard';
import MetaAdsLeads from './MetaAdsLeads';
import MetaAdsLeadDetail from './MetaAdsLeadDetail';
import MetaAdsSettings from './MetaAdsSettings';
import MetaAdsSyncLogs from './MetaAdsSyncLogs';
import MetaAdsSetupGuide from './MetaAdsSetupGuide';

const TABS = [
  { key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { key: 'leads', label: 'Leads', icon: Users },
  { key: 'setup-guide', label: 'Setup Guide', icon: BookOpen },
  { key: 'settings', label: 'Settings', icon: Settings },
  { key: 'sync-logs', label: 'Sync Logs', icon: History },
];

export default function MetaAdsPage() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [viewLeadId, setViewLeadId] = useState(null);

  const handleViewLead = (leadId) => {
    setViewLeadId(leadId);
    setActiveTab('lead-detail');
  };

  const handleBackFromDetail = () => {
    setViewLeadId(null);
    setActiveTab('leads');
  };

  // Special views (settings, sync-logs, lead-detail, setup-guide) show without tabs
  if (activeTab === 'settings') {
    return <MetaAdsSettings onBack={() => setActiveTab('dashboard')} />;
  }
  if (activeTab === 'sync-logs') {
    return <MetaAdsSyncLogs onBack={() => setActiveTab('dashboard')} />;
  }
  if (activeTab === 'setup-guide') {
    return <MetaAdsSetupGuide onBack={() => setActiveTab('dashboard')} />;
  }
  if (activeTab === 'lead-detail' && viewLeadId) {
    return <MetaAdsLeadDetail leadId={viewLeadId} onBack={handleBackFromDetail} />;
  }

  return (
    <div className="space-y-6" data-testid="meta-ads-page">
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Meta Ads</h1>
          <p className="text-sm text-slate-500">Manage leads from Facebook & Instagram ad campaigns</p>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="flex gap-1 bg-white rounded-xl border p-1" data-testid="meta-ads-tabs">
        {TABS.map(t => (
          <button key={t.key} onClick={() => setActiveTab(t.key)}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
              activeTab === t.key
                ? 'bg-slate-900 text-white'
                : 'text-slate-500 hover:bg-slate-50 hover:text-slate-700'
            }`}
            data-testid={`tab-${t.key}`}
          >
            <t.icon size={16} />
            {t.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === 'dashboard' && <MetaAdsDashboard />}
      {activeTab === 'leads' && <MetaAdsLeads onViewLead={handleViewLead} />}
    </div>
  );
}
